module.exports = __webpack_public_path__ + "static/media/me-about.28d3d512.jpg";